import getCookie from './functions/getCookie';
import setCookie from './functions/setCookie';
import resetCookie from './functions/resetCookie';
import cookieIsType from './helpers/cookieIsType';
import getConsentMarkup from './helpers/createConsentMarkup';
import { config } from './config/config';
import translations from './config/translations';
import appendConsentedScripts from './helpers/appendConsentedScripts';
import consentTypes from './helpers/consentTypes';

class Consent {
    constructor() {
        this.selectedConsentTypes = [];
        this.moreInfoOpen = false;
    }

    init() {
        this.initConsentTypes();

        window.addEventListener('load', () => {
            this.initModalToggles();
            this.initModal();
            appendConsentedScripts(this.selectedConsentTypes);
        });
    }

    initModal() {
        const consentSubmitted = getCookie('consent-submitted');

        if (consentSubmitted) {
            return;
        }

        this.openModal();
    }

    initConsentTypes() {
        for (let i = 0; i < config.availableConsentTypes.length; i += 1) {
            const consentType = config.availableConsentTypes[i];
            if (consentType === consentTypes.CONSENT_TYPE_NECESSARY) {
                this.selectedConsentTypes.push(consentType);
                // eslint-disable-next-line no-continue
                continue;
            }

            if (getCookie(`consent-type-${consentType}`)) {
                this.selectedConsentTypes.push(consentType);
            }
        }
    }

    toggleConsentType(consentType) {
        const index = this.selectedConsentTypes.indexOf(consentType);

        if (index !== -1) {
            this.selectedConsentTypes.splice(index, 1);

            return;
        }

        this.selectedConsentTypes.push(consentType);
    }

    triggerMoreInfo() {
        const moreInfoContainer = document.getElementById('cookie-consent-more-info-container');
        const triggerTextSpan = document.getElementsByClassName('cookie-consent-more-info-trigger-text').item(0);

        if (!this.moreInfoOpen) {
            moreInfoContainer.className = 'cookie-consent-more-info-container open';
            triggerTextSpan.className = 'cookie-consent-more-info-trigger-text open';
            triggerTextSpan.innerText = translations.hideDetailsText;
        }

        if (this.moreInfoOpen) {
            moreInfoContainer.className = 'cookie-consent-more-info-container';
            triggerTextSpan.className = 'cookie-consent-more-info-trigger-text';
            triggerTextSpan.innerText = translations.showDetailsText;
        }

        this.moreInfoOpen = !this.moreInfoOpen;
    }

    resetExternalCookiesByType(consentType) {
        const hostnameArray = window.location.hostname.split('.');
        let domain = '';

        if (hostnameArray[1] !== 'localhost') {
            domain = `.${hostnameArray[1]}.${hostnameArray[2]}`;
        }

        const cookieNames = document.cookie.split(/=[^;]*(?:;\s*|$)/);

        // Loop to reset all Cookies that match filter
        for (let i = 0; i < cookieNames.length; i += 1) {
            if (cookieIsType(cookieNames[i], consentType)) {
                resetCookie(cookieNames[i], domain);
            }
        }
    }

    resetCookies() {
        for (let i = 0; i < config.availableConsentTypes.length; i += 1) {
            const consentType = config.availableConsentTypes[i];
            if (consentType === consentTypes.CONSENT_TYPE_NECESSARY) {
                // eslint-disable-next-line no-continue
                continue;
            }

            if (consentType === consentTypes.CONSENT_TYPE_PREFERENCES) {
                resetCookie(`consent-type-${consentType}`);

                // eslint-disable-next-line no-continue
                continue;
            }

            resetCookie(`consent-type-${consentType}`);
            this.resetExternalCookiesByType(consentType);
        }
    }

    submitConsent(e, consentTypesToSubmit) {
        const submitAll = consentTypesToSubmit === config.availableConsentTypes;
        setCookie('consent-submitted', true);
        this.resetCookies();

        for (let i = 0; i < consentTypesToSubmit.length; i += 1) {
            const consentType = consentTypesToSubmit[i];
            if (submitAll) {
                const input = document.querySelectorAll(`input#${consentType}`).item(0);
                input.setAttribute('checked', 'checked');
            }

            setCookie(`consent-type-${consentType}`, true);
        }

        e.currentTarget.className = 'cookie-consent-button loading';

        appendConsentedScripts(consentTypesToSubmit);
        const cookieConsentElement = document.querySelector('.cookie-consent-backdrop');
        cookieConsentElement.parentNode.removeChild(cookieConsentElement);
    }

    initModalToggles() {
        const toggles = document.querySelectorAll(config.querySelectorForToggleModal);

        for (let i = 0; i < toggles.length; i += 1) {
            toggles[i].addEventListener('click', (e) => {
                e.preventDefault();
                this.openModal();
            });
        }
    }

    openModal() {
        const consentNode = getConsentMarkup();
        document.body.appendChild(consentNode);

        setTimeout(() => {
            consentNode.className = 'cookie-consent-backdrop initialized';

            this.initEvents();
        }, 400);
    }

    initEvents() {
        const inputs = document.getElementsByClassName('cookie-consent-select-input');
        const submitButton = document.getElementById('cookie-consent-submit-button');
        const submitAllButton = document.getElementById('cookie-consent-submit-all-button');
        const moreInfoTrigger = document.getElementById('cookie-consent-more-info-trigger');

        for (let i = 0; i < inputs.length; i += 1) {
            inputs[i].addEventListener('change', (e) => {
                if (e.currentTarget.id) this.toggleConsentType(e.currentTarget.id);
            });
        }

        submitAllButton.addEventListener('click', (e) => {
            this.submitConsent(e, config.availableConsentTypes);
        });

        submitButton.addEventListener('click', (e) => {
            this.submitConsent(e, this.selectedConsentTypes);
        });

        moreInfoTrigger.addEventListener('click', () => {
            this.triggerMoreInfo();
        });
    }
}

export default new Consent();
